import type { FileIconProps } from './FileIcon';

function FileImageIcon({ extension, color, size = 28, ...props }: FileIconProps) {
  return (
    <svg width={size} height={size * 1.25} viewBox='0 0 28 35' fill={color} {...props}>
      <g clipPath='url(#prefix__clip0)'>
        <path d='M4 35h20a4 4 0 004-4V4a4 4 0 00-4-4H4a4 4 0 00-4 4v27a4 4 0 004 4z' />
        <path
          opacity={0.25}
          d='M4.5 14L-8 30v17h38V36L13.5 17l-4 4.5-5-7.5z'
          fill='url(#prefix__paint0_linear)'
        />
        <circle opacity={0.4} cx={21} cy={13} r={3} fill='#fff' />
        <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
          {extension?.toUpperCase()}
        </text>
      </g>
      <defs>
        <linearGradient
          id='prefix__paint0_linear'
          x1={11}
          y1={14}
          x2={11}
          y2={34.5}
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <clipPath id='prefix__clip0'>
          <path d='M0 4a4 4 0 014-4h20a4 4 0 014 4v27a4 4 0 01-4 4H4a4 4 0 01-4-4V4z' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FileImageIcon;
